import { Typography } from 'antd'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { alphabeticalCompare } from '@cims-online/shared'
import { useLocation } from 'react-router-dom'

export function useStatusColumn<
  T extends { active: boolean }
>(): CIMSColumn<T> {
  const queryParams = new URLSearchParams(useLocation().search)
  const hasInactiveQueryParam = queryParams.get('inactive') === 'inactive'

  return {
    title: 'Status',
    help: 'The current workflow status of the Mix Design',
    render: ({ active }) => {
      return (
        <Typography.Text type={active ? 'success' : 'secondary'}>
          {active ? 'Active' : 'Inactive'}
        </Typography.Text>
      )
    },
    filter: {
      default: !hasInactiveQueryParam,
      type: 'boolean',
      with: 'value',
      labels: { true: 'Active', false: 'Inactive' },
      value: ({ active }) => active,
    },
    sort: {
      with: 'callback',
      onCompare: (a, b) => {
        const A = a.active ? 1 : 2
        const B = b.active ? 1 : 2
        return alphabeticalCompare(A, B)
      },
      default: 'ascend',
      priority: 1,
    },
    align: 'center',
    width: 125,
  }
}
